import { FC, useRef } from "react";

import Box from "@mui/material/Box";

import { useSummaryOverflow } from "@/common/hooks/useSummaryOverflow";
import { TableMultiSelectCell } from "@/dashboard-design-system/DashboardTableCell/TableSelectCells";

export interface TableOverflowMultiSelectCellProps {
  labels: string[];
}

export const TableOverflowMultiSelectCell: FC<TableOverflowMultiSelectCellProps> = ({ labels }) => {
  const containerRef = useRef<HTMLElement | null>(null);
  const measureRef = useRef<HTMLElement | null>(null);
  const visibleCount = useSummaryOverflow({
    containerRef,
    measureRef,
    itemCount: labels.length,
    itemsKey: JSON.stringify(labels),
    minVisibleCount: 1,
  });

  return (
    <Box
      sx={{
        position: "relative",
        minWidth: 0,
        overflow: "hidden",
        "& [data-test='table-multi-select-cell']": { paddingX: 0, flexShrink: 0 },
      }}
    >
      <Box ref={containerRef} minWidth={0}>
        <TableMultiSelectCell labels={labels} visibleCount={visibleCount} />
      </Box>
      <Box
        aria-hidden
        ref={(element: HTMLElement | null) => {
          const row = element?.firstElementChild;
          measureRef.current = row instanceof HTMLElement ? row : null;
        }}
        sx={{ position: "absolute", visibility: "hidden", pointerEvents: "none", width: "max-content", top: 0 }}
      >
        <TableMultiSelectCell labels={[...labels, `+${labels.length}`]} visibleCount={labels.length + 1} />
      </Box>
    </Box>
  );
};
